const FLAG_BY_UNAVAILABILITY_DAY_TYPE = {
    full: 'alert',
    partial: 'warning',
};
// Omit `flagAs` to flag every day by its own type, matching the UnavailabilityCalendar legend.
export function resolveUnavailabilityFlaggedDates(unavailabilityDays, flagAs) {
    return unavailabilityDays.map((day) => ({
        date: day.date,
        flag: flagAs ?? FLAG_BY_UNAVAILABILITY_DAY_TYPE[day.type],
    }));
}
